/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Clever Analytics Prices Public API
 * OpenAPI spec version: 1.0.0
 */
import { pricesInstance } from '../../api/client';
export type GetCommodityCurrentType = typeof GetCommodityCurrentType[keyof typeof GetCommodityCurrentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCommodityCurrentType = {
  BID: 'BID',
  SETTLE: 'SETTLE',
} as const;

export type GetCommodityCurrentCurrency = typeof GetCommodityCurrentCurrency[keyof typeof GetCommodityCurrentCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCommodityCurrentCurrency = {
  CZK: 'CZK',
  EUR: 'EUR',
  USD: 'USD',
  RON: 'RON',
} as const;

export type GetCommodityCurrentParams = {
currency: GetCommodityCurrentCurrency;
type: GetCommodityCurrentType;
'date-from'?: string;
'date-to'?: string;
};

export type GetCommodityRatesType = typeof GetCommodityRatesType[keyof typeof GetCommodityRatesType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCommodityRatesType = {
  BID: 'BID',
  SETTLE: 'SETTLE',
} as const;

export type GetCommodityRatesCurrency = typeof GetCommodityRatesCurrency[keyof typeof GetCommodityRatesCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCommodityRatesCurrency = {
  CZK: 'CZK',
  EUR: 'EUR',
  USD: 'USD',
  RON: 'RON',
} as const;

export type GetCommodityRatesPeriod = typeof GetCommodityRatesPeriod[keyof typeof GetCommodityRatesPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCommodityRatesPeriod = {
  CURRENT: 'CURRENT',
  NEXT: 'NEXT',
} as const;

export type GetCommodityRatesParams = {
period: GetCommodityRatesPeriod;
currency: GetCommodityRatesCurrency;
type: GetCommodityRatesType;
'date-from'?: string;
'date-to'?: string;
};

export type GetRateParams = {
'date-from'?: string;
'date-to'?: string;
};

export type GetPredictionParams = {
year?: number;
zip: string;
};

export type GetPublicLastCurrency = typeof GetPublicLastCurrency[keyof typeof GetPublicLastCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPublicLastCurrency = {
  CZK: 'CZK',
  EUR: 'EUR',
  USD: 'USD',
  RON: 'RON',
} as const;

export type GetPublicLastParams = {
currency: GetPublicLastCurrency;
};

export type CommodityCurrentToPeriod = typeof CommodityCurrentToPeriod[keyof typeof CommodityCurrentToPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityCurrentToPeriod = {
  CURRENT: 'CURRENT',
  NEXT: 'NEXT',
} as const;

export type CommodityCurrentToQuarter = typeof CommodityCurrentToQuarter[keyof typeof CommodityCurrentToQuarter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityCurrentToQuarter = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4',
} as const;

export type CommodityCurrentToMonth = typeof CommodityCurrentToMonth[keyof typeof CommodityCurrentToMonth];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityCurrentToMonth = {
  JANUARY: 'JANUARY',
  FEBRUARY: 'FEBRUARY',
  MARCH: 'MARCH',
  APRIL: 'APRIL',
  MAY: 'MAY',
  JUNE: 'JUNE',
  JULY: 'JULY',
  AUGUST: 'AUGUST',
  SEPTEMBER: 'SEPTEMBER',
  OCTOBER: 'OCTOBER',
  NOVEMBER: 'NOVEMBER',
  DECEMBER: 'DECEMBER',
} as const;

export interface CommodityCurrentTo {
  year: number;
  month: CommodityCurrentToMonth;
  quarter: CommodityCurrentToQuarter;
  rate: number;
  period?: CommodityCurrentToPeriod;
  diff?: number;
}

export type CommodityRatesToType = typeof CommodityRatesToType[keyof typeof CommodityRatesToType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityRatesToType = {
  BID: 'BID',
  SETTLE: 'SETTLE',
} as const;

export type CommodityRatesToCurrency = typeof CommodityRatesToCurrency[keyof typeof CommodityRatesToCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityRatesToCurrency = {
  CZK: 'CZK',
  EUR: 'EUR',
  USD: 'USD',
  RON: 'RON',
} as const;

export type CommodityRatesToPeriod = typeof CommodityRatesToPeriod[keyof typeof CommodityRatesToPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityRatesToPeriod = {
  CURRENT: 'CURRENT',
  NEXT: 'NEXT',
} as const;

export type CommodityRatesToCommodity = typeof CommodityRatesToCommodity[keyof typeof CommodityRatesToCommodity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityRatesToCommodity = {
  WHEAT: 'WHEAT',
  RAPESEED: 'RAPESEED',
  CRUDE_OIL: 'CRUDE_OIL',
} as const;

export interface CommodityRateTo {
  datetime: string;
  rate?: number;
}

export interface CommodityRatesTo {
  commodity: CommodityRatesToCommodity;
  period: CommodityRatesToPeriod;
  currency: CommodityRatesToCurrency;
  rates: CommodityRateTo[];
  type: CommodityRatesToType;
  diff?: number;
}

export type CurrencyRatesToService = typeof CurrencyRatesToService[keyof typeof CurrencyRatesToService];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrencyRatesToService = {
  ECB: 'ECB',
  CNB: 'CNB',
} as const;

export type CurrencyRatesToCurrency2 = typeof CurrencyRatesToCurrency2[keyof typeof CurrencyRatesToCurrency2];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrencyRatesToCurrency2 = {
  CZK: 'CZK',
  EUR: 'EUR',
  USD: 'USD',
  RON: 'RON',
} as const;

export type CurrencyRatesToCurrency1 = typeof CurrencyRatesToCurrency1[keyof typeof CurrencyRatesToCurrency1];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrencyRatesToCurrency1 = {
  CZK: 'CZK',
  EUR: 'EUR',
  USD: 'USD',
  RON: 'RON',
} as const;

export interface CurrencyRateTo {
  date: string;
  rate: number;
}

export interface CurrencyRatesTo {
  currency1: CurrencyRatesToCurrency1;
  currency2: CurrencyRatesToCurrency2;
  rates: CurrencyRateTo[];
  service: CurrencyRatesToService;
}

export type PredictionRatesToRegion = typeof PredictionRatesToRegion[keyof typeof PredictionRatesToRegion];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PredictionRatesToRegion = {
  JIHOCESKY: 'JIHOCESKY',
  JIHOMORAVSKY: 'JIHOMORAVSKY',
  KARLOVARSKY: 'KARLOVARSKY',
  KRALOVEHRADECKY: 'KRALOVEHRADECKY',
  LIBERECKY: 'LIBERECKY',
  MORAVSKOSLEZSKY: 'MORAVSKOSLEZSKY',
  OLOMOUCKY: 'OLOMOUCKY',
  PARDUBICKY: 'PARDUBICKY',
  PLZENSKY: 'PLZENSKY',
  PRAHA: 'PRAHA',
  STREDOCESKY: 'STREDOCESKY',
  USTECKY: 'USTECKY',
  VYSOCINA: 'VYSOCINA',
  ZLINSKY: 'ZLINSKY',
} as const;

export type PredictionRatesToDistrict = typeof PredictionRatesToDistrict[keyof typeof PredictionRatesToDistrict];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PredictionRatesToDistrict = {
  CESKE_BUDEJOVICE: 'CESKE_BUDEJOVICE',
  CESKY_KRUMLOV: 'CESKY_KRUMLOV',
  JINDRICHUV_HRADEC: 'JINDRICHUV_HRADEC',
  PISEK: 'PISEK',
  PRACHATICE: 'PRACHATICE',
  STRAKONICE: 'STRAKONICE',
  TABOR: 'TABOR',
  BLANSKO: 'BLANSKO',
  BRNO_MESTO: 'BRNO_MESTO',
  BRNO_VENKOV: 'BRNO_VENKOV',
  BRECLAV: 'BRECLAV',
  HODONIN: 'HODONIN',
  VYSKOV: 'VYSKOV',
  ZNOJMO: 'ZNOJMO',
  CHEB: 'CHEB',
  KARLOVY_VARY: 'KARLOVY_VARY',
  SOKOLOV: 'SOKOLOV',
  HRADEC_KRALOVE: 'HRADEC_KRALOVE',
  JICIN: 'JICIN',
  NACHOD: 'NACHOD',
  RYCHNOV_NAD_KNEZNOU: 'RYCHNOV_NAD_KNEZNOU',
  TRUTNOV: 'TRUTNOV',
  CESKA_LIPA: 'CESKA_LIPA',
  JABLONEC_NAD_NISOU: 'JABLONEC_NAD_NISOU',
  LIBEREC: 'LIBEREC',
  SEMILY: 'SEMILY',
  BRUNTAL: 'BRUNTAL',
  FRYDEK_MISTEK: 'FRYDEK_MISTEK',
  KARVINA: 'KARVINA',
  NOVY_JICIN: 'NOVY_JICIN',
  OPAVA: 'OPAVA',
  OSTRAVA: 'OSTRAVA',
  JESENIK: 'JESENIK',
  OLOMOUC: 'OLOMOUC',
  PROSTEJOV: 'PROSTEJOV',
  PREROV: 'PREROV',
  SUMPERK: 'SUMPERK',
  CHRUDIM: 'CHRUDIM',
  PARDUBICE: 'PARDUBICE',
  SVITAVY: 'SVITAVY',
  USTI_NAD_ORLICI: 'USTI_NAD_ORLICI',
  DOMAZLICE: 'DOMAZLICE',
  KLATOVY: 'KLATOVY',
  PLZEN_MESTO: 'PLZEN_MESTO',
  PLZEN_JIH: 'PLZEN_JIH',
  PLZEN_SEVER: 'PLZEN_SEVER',
  ROKYCANY: 'ROKYCANY',
  TACHOV: 'TACHOV',
  PRAHA: 'PRAHA',
  BENESOV: 'BENESOV',
  BEROUN: 'BEROUN',
  KLADNO: 'KLADNO',
  KOLIN: 'KOLIN',
  KUTNA_HORA: 'KUTNA_HORA',
  MELNIK: 'MELNIK',
  MLADA_BOLESLAV: 'MLADA_BOLESLAV',
  NYMBURK: 'NYMBURK',
  PRAHA_VYCHOD: 'PRAHA_VYCHOD',
  PRAHA_ZAPAD: 'PRAHA_ZAPAD',
  PRIBRAM: 'PRIBRAM',
  RAKOVNIK: 'RAKOVNIK',
  DECIN: 'DECIN',
  CHOMUTOV: 'CHOMUTOV',
  LITOMERICE: 'LITOMERICE',
  LOUNY: 'LOUNY',
  MOST: 'MOST',
  TEPLICE: 'TEPLICE',
  USTI_NAD_LABEM: 'USTI_NAD_LABEM',
  HAVLICKUV_BROD: 'HAVLICKUV_BROD',
  JIHLAVA: 'JIHLAVA',
  PELHRIMOV: 'PELHRIMOV',
  TREBIC: 'TREBIC',
  ZDAR_NAD_SAZAVOU: 'ZDAR_NAD_SAZAVOU',
  KROMERIZ: 'KROMERIZ',
  UHERSKE_HRADISTE: 'UHERSKE_HRADISTE',
  VSETIN: 'VSETIN',
  ZLIN: 'ZLIN',
} as const;

export type PredictionRatesToCommodity = typeof PredictionRatesToCommodity[keyof typeof PredictionRatesToCommodity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PredictionRatesToCommodity = {
  SPRING_BARLEY: 'SPRING_BARLEY',
  WINTER_WHEAT: 'WINTER_WHEAT',
  WINTER_RAPESEED: 'WINTER_RAPESEED',
  CORN: 'CORN',
} as const;

export interface PredictionRateTo {
  date: string;
  min?: number;
  max?: number;
  average3Year?: number;
  deviation30Pct?: number;
  prediction?: number;
}

export interface PredictionRatesTo {
  commodity: PredictionRatesToCommodity;
  district: PredictionRatesToDistrict;
  region: PredictionRatesToRegion;
  year: number;
  rates: PredictionRateTo[];
}

export type CommodityCurrentLastToPeriod = typeof CommodityCurrentLastToPeriod[keyof typeof CommodityCurrentLastToPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityCurrentLastToPeriod = {
  CURRENT: 'CURRENT',
  NEXT: 'NEXT',
} as const;

export type CommodityCurrentLastToQuarter = typeof CommodityCurrentLastToQuarter[keyof typeof CommodityCurrentLastToQuarter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityCurrentLastToQuarter = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4',
} as const;

export type CommodityCurrentLastToMonth = typeof CommodityCurrentLastToMonth[keyof typeof CommodityCurrentLastToMonth];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityCurrentLastToMonth = {
  JANUARY: 'JANUARY',
  FEBRUARY: 'FEBRUARY',
  MARCH: 'MARCH',
  APRIL: 'APRIL',
  MAY: 'MAY',
  JUNE: 'JUNE',
  JULY: 'JULY',
  AUGUST: 'AUGUST',
  SEPTEMBER: 'SEPTEMBER',
  OCTOBER: 'OCTOBER',
  NOVEMBER: 'NOVEMBER',
  DECEMBER: 'DECEMBER',
} as const;

export interface CommodityCurrentLastTo {
  year: number;
  month: CommodityCurrentLastToMonth;
  quarter: CommodityCurrentLastToQuarter;
  rate: number;
  period?: CommodityCurrentLastToPeriod;
}




type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


  /**
 * @summary Last price for a commodity
 */
export const getPublicLast = (
    id: 'WHEAT' | 'RAPESEED' | 'CRUDE_OIL',
    params: GetPublicLastParams,
 options?: SecondParameter<typeof pricesInstance>,) => {
      return pricesInstance<CommodityCurrentLastTo>(
      {url: `/can-prices/public/api/commodity/last/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get crop yield prediction for a location
 */
export const getPrediction = (
    id: 'SPRING_BARLEY' | 'WINTER_WHEAT' | 'WINTER_RAPESEED' | 'CORN',
    params: GetPredictionParams,
 options?: SecondParameter<typeof pricesInstance>,) => {
      return pricesInstance<PredictionRatesTo>(
      {url: `/can-prices/api/prediction/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get historic currency prices
 */
export const getRate = (
    currency1: 'CZK' | 'EUR' | 'USD' | 'RON',
    currency2: 'CZK' | 'EUR' | 'USD' | 'RON',
    params?: GetRateParams,
 options?: SecondParameter<typeof pricesInstance>,) => {
      return pricesInstance<CurrencyRatesTo>(
      {url: `/can-prices/api/currency/rate/${currency1}/${currency2}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get historic commodity prices
 */
export const getCommodityRates = (
    id: 'WHEAT' | 'RAPESEED' | 'CRUDE_OIL',
    params: GetCommodityRatesParams,
 options?: SecondParameter<typeof pricesInstance>,) => {
      return pricesInstance<CommodityRatesTo>(
      {url: `/can-prices/api/commodity/rate/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @deprecated
 * @summary Load historic prices from matif
 */
export const loadPrices = (
    
 options?: SecondParameter<typeof pricesInstance>,) => {
      return pricesInstance<void>(
      {url: `/can-prices/api/commodity/rate/load`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get current commodity prices
 */
export const getCommodityCurrent = (
    id: 'WHEAT' | 'RAPESEED' | 'CRUDE_OIL',
    params: GetCommodityCurrentParams,
 options?: SecondParameter<typeof pricesInstance>,) => {
      return pricesInstance<CommodityCurrentTo[]>(
      {url: `/can-prices/api/commodity/current/${id}`, method: 'GET',
        params
    },
      options);
    }
  
export type GetPublicLastResult = NonNullable<Awaited<ReturnType<typeof getPublicLast>>>
export type GetPredictionResult = NonNullable<Awaited<ReturnType<typeof getPrediction>>>
export type GetRateResult = NonNullable<Awaited<ReturnType<typeof getRate>>>
export type GetCommodityRatesResult = NonNullable<Awaited<ReturnType<typeof getCommodityRates>>>
export type LoadPricesResult = NonNullable<Awaited<ReturnType<typeof loadPrices>>>
export type GetCommodityCurrentResult = NonNullable<Awaited<ReturnType<typeof getCommodityCurrent>>>
